import React from 'react';
import PropTypes from 'prop-types';

import { Scrollbar, A11y   } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
//import 'swiper/scss';
//import 'swiper/scss/navigation';
//import 'swiper/scss/pagination';

import './styles.scss'

Partner.propTypes = {
    data: PropTypes.array,
};

function Partner(props) {

    const {data} = props;

    return (
        <section className="tf-section partner">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="tf-title" data-aos="fade-up" data-aos-duration="800">
                            <p className="h8 sub-title">partners</p>
                            <h4 className="title">Current Projects</h4>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="item-parner center" data-aos="fade-up" data-aos-duration="800">
                            <div className='partnerContainer'>
                                {
                                    data.slice(0,9).map((item,idx) => (
                                       
                                        <div className="item">
                                                <div>
                                                    <img src={item.img} className='circular-element' alt="Crybox" />
                                                    <h6>{item.Title}</h6>
                                                </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Partner;